import { HttpErrorResponse } from '@angular/common/http';
import { ElementRef, Injectable, Optional, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { SnackNotificationComponent } from '../../template/snack-notification/snack-notification.component';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { Router } from '@angular/router';
import { Country, State, City } from 'country-state-city';
import momentTZ from 'moment-timezone';


@Injectable({
  providedIn: 'root',
})
export class UtilService {
  hoverCheck?: boolean;
  // current themes for sidebar light: menu_light || dark: menu_dark
  theme:string = 'menu_light'
  expandedSidebar?: boolean;
  // self onboarding variable
  sidebarListIndex = new BehaviorSubject<number>(0);
  private activeListIndex = new BehaviorSubject<number>(0);
  private previousIndex = new BehaviorSubject<number>(0);
  private clearFilter = new BehaviorSubject<number>(0);
  private ctcFilters = new BehaviorSubject<any>('');
  ctcFilter$ = this.ctcFilters.asObservable()
  clearAllFilter$ = this.clearFilter.asObservable()
  holidaySettings: any
  sidebarMaxIndex: number = 0;
  activeListItemIndex: number = 0;
  // sidebar first level menu
  isSidebarOpen: boolean = false;
  sidebarTransition: boolean = false;
  header_emp_info = new BehaviorSubject<any>(undefined);
  openInlineEdit = new BehaviorSubject<any>(undefined);
  sidebarActiveIcon = new BehaviorSubject<any>(undefined);
  updateProfileInfo = new BehaviorSubject<any>(undefined);
  auto_clock_out = new BehaviorSubject<any>(undefined);
  clock_in = new BehaviorSubject<any>(undefined);
  employee_profile_data = new BehaviorSubject<any>(undefined);
  accountID: any;
  taskID: any;
  task_url:any
  employeeID: any;
  renderer:any;
  active_account:any

  constructor( 
    private snackBar: MatSnackBar, 
    private _router: Router,
    private _renderer:RendererFactory2
  ) {
    this.renderer = this._renderer.createRenderer(null,null);
  }



  // Right Side Bar
  private statusService = new BehaviorSubject<boolean>(false);
  currentStatus = this.statusService.asObservable();
  changeRightSideBarStatus(status: boolean) {
    this.statusService.next(status);
  }
  getRightSideBarStatus(): boolean {
    return this.statusService.value;
  }

  // Left Side Bar
  private menuType = new BehaviorSubject<string>('default');
  currentMenuType = this.menuType.asObservable();
  changeLeftSidebarMenuType(type: string) {
    this.menuType.next(type);
  }
  get getLeftSidebarMenuType(): string {
    return this.menuType.value;
  }

  /* setDialogFieldErrors(dialogRef: MatDialogRef<any>, formGroup: FormGroup, httpError: HttpErrorResponse) {
    let err = httpError.error;
    if (httpError.status === 400 && err) {
      let errorKeys = Object.keys(err);
      errorKeys.forEach(e => {
        if (formGroup == null || !formGroup.get(e)) {
          dialogRef.close();
          this.showSnackNotification("danger", err[e]);
        } else {
          formGroup.get(e)?.setErrors({"customError": err[e]});
        }
      });
    }
  } */

  get currentYear() {
    return new Date().getFullYear();
  }

  getBadgeName(name: string) {
    var acronym = name?.match(/\b(\w)/g)?.join('');
    var output = acronym?.substr(0, 1);
    return output?.toUpperCase();
  }

  getOrgBadgeName(name: string) {
    var acronym = name
      .match(/\b(\w)/g)
      ?.join('')
      .slice(0, 1)
      .toUpperCase();
    return acronym;
  }

  customFieldValidator(regExp: RegExp, errorMsg?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = regExp.test(control.value);
      if (control.value) {
        return isValid ? null : {
          customFieldValidationError: errorMsg ? errorMsg : 'Please enter valid input',
        };
      }
      return null
    };
  }

  customNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const startsWithAlphabet = /^[a-zA-Z]/.test(control.value);
      const containsSpecialChars = /^[a-zA-Z0-9/'&,(). -]*$/.test(control.value);
      if (!startsWithAlphabet) {
        return {
          customFieldValidationError: "Field must start with an alphabet",
        };
      }

      if (!containsSpecialChars) {
        return {
          customFieldValidationError: "Field only allowed special characters  ( - , / ' & ( ) )",
        };
      }

      return null;
    };
  }
  
  max24Validator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = parseFloat(control.value);
      if (isNaN(value) || value > 24) {
        return { 'max24': true };
      }
      return null;
    };
  }

  lessThanmax24Validator(otherField: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = parseFloat(control.value);
      const otherFieldValue = parseFloat(control?.root?.get(otherField)?.value);

      if (!isNaN(otherFieldValue) && value > otherFieldValue) {
        return { 'lessThanOtherField': true }; // Return error object if value is greater than other field value
      }
      return null; // Return null if value is valid
    };
  }

  passwordMatchValidator(c: FormGroup) {
    const doesMatch =
      c.get('password')?.value === c.get('confirm_password')?.value;
    if (!doesMatch)
      c.get('confirm_password')?.setErrors({
        customFieldValidationError: 'Password does not match!',
      });
    return doesMatch ? null : { invalid: true };
  }

  setFormFieldErrors(
    formGroup: FormGroup,
    httpError: HttpErrorResponse,
    showSnack?: boolean
  ) {
    let err = httpError.error;
    if (httpError.status === 400 && err) {
      let errorKeys = Object.keys(err);
      errorKeys.forEach((e) => {
        if (formGroup == null || !formGroup.get(e)) {
          if (showSnack) this.showSnackNotification('danger', err[e]);
        } else {
          formGroup.get(e)?.setErrors({ customError: err[e] });
        }
      });
    }
  }

  getErrorMessage(err: any): string {
    let error: any;
    let message: string = ''
    if (err?.graphQLErrors) {
      error = (err.graphQLErrors[0])
    }
    else error = err[0];
    if (error) {
      let errorKeys = Object.keys(error);
      errorKeys.forEach((e: any) => {
        if (e != "code") {
          message = error[e][0]
        }
      });
    }
    return message
  }


  setFormFieldGraphQlErrors(err: any, showSnack?: boolean, formGroup?: FormGroup) {
    let error: any;
    if (err?.graphQLErrors) {
      error = (err.graphQLErrors[0])
    }
    else error = err[0];
    if (error) {
      let errorKeys = Object.keys(error);
      errorKeys.forEach((e: any) => {
        if (formGroup == null || !formGroup.get(e)) {
          if (showSnack && e != "code") {
            this.snackNotification('error', 'Uh oh!', error[e]);
          }
        }
        else {
          formGroup?.get(e)?.setErrors({ customError: error[e] });
        }
      });
    }
  }

  changeTextToApiFormat(text: string): string {
    return text?.toLowerCase()?.replace(/\s+/g, '_');
  }

  changeApiKeyToTextFormat(key: string) {
    return key.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  getChipAvatar(profile_url: any) {
    return profile_url?.includes('.com') ? profile_url : 'assets/images/icons/pfp-placeholder.png'
  }

  isEllipsisActive(e: HTMLElement): boolean {
    return e ? e.offsetWidth < e.scrollWidth : false;
  }

  isSearchFieldValid(searchText: string, regExp?: RegExp) {
    const pattern = regExp ? regExp : /^[a-zA-Z0-9\-\@\.\s]*$/;
    const isValid = searchText != '' ? pattern.test(searchText) : false;
    return isValid;
  }

  snackNotification(action: any, title: any, content: any) {
    this.snackBar.openFromComponent(SnackNotificationComponent, {
      data: {
        action: action,
        title: title,
        content: content
      },
      verticalPosition: 'top',
      horizontalPosition: 'right'
    }); 
  }

  showSnackNotification(
    colorName: string,
    text: any,
    placementFrom?: any,
    placementAlign?: any
  ) {
    this.snackBar.open(text, '', {
      duration: 2000,
      verticalPosition: placementFrom ? placementFrom : 'top',
      horizontalPosition: placementAlign ? placementAlign : 'right',
      panelClass: 'snackbar-' + colorName,
    });
  }

  convertBase64ToFile(base64Data: any, fileName: string) {
    var arr = base64Data.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  }

  getFormattedDate(date?: any, format?: string | null, type?: string) {
    let defaultFormat = 'DD-MM-YYYY';
    if (type === 'time') defaultFormat = format ? format : 'DD-MM-YYYY hh:mm A';
    let formatString = format ? format : defaultFormat;
    return date ? moment(date).format(formatString) : moment().format(formatString);
  }

  redirectToProfile(id: any, action?: string) {
    if (action === 'new-tab') {
      window.open(`accounts/${id}/profile`)
      window.open(`accounts/${id}/profile`)
    }
    else if(action === 'schedules') {

      this._router.navigate([`account-details/${id}/schedules`])
    }
    else{
      this._router.navigate([`task/${id}/task-detail`])
    }
  }

  closeRightSidebar() {
    // code to remove query params when user manually
    // closes a screen
    this._router.navigate([], { queryParams: { page: null } });
    return false;
  }

  getStateListFromCountyName(event: any) {
    const countryID: any = Country.getAllCountries().find((item: any) => item.name === event)?.isoCode ?? null;
    let state = State.getStatesOfCountry(countryID);
    return ({ state: state, value: countryID });
  }

  getCityListFromStateName(event: any, items: any) {
    const stateID = items?.state?.find((item: any) => item.name === event)?.isoCode ?? null;
    let cities = City?.getCitiesOfState(items?.value, stateID);
    return ({ cities: cities, value: stateID });
  }

  getTimeZoneFromCountry(event: any) {
    const countryID: any = Country.getAllCountries().find((item: any) => item.name === event)?.isoCode ?? null;
    let tz: any = momentTZ.tz.zonesForCountry(countryID)
    return tz;
  }


  //convert titleCase

convertToTitleCase(value:any) {
    const name = value?.toLowerCase()?.split(' ')?.map((word:any) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    return name;
  }
  
 //monthNames
  getMonthNames() {
    const monthNames = [];
    for (let month = 0; month < 12; month++) {
      const date = new Date(2000, month, 1); // Using a fixed year (2000) to ensure consistency
      const monthName = date.toLocaleString('default', { month: 'long' });
      monthNames.push(monthName);
    }
    return monthNames;
  }

  //apply filterStyles in ag grid 
  onFilterChanged(filter:any,event:any,gridApi:any) {    
    const filterModel = gridApi.getFilterModel();
    let index = event.columns[0].userProvidedColDef.headerComponentParams?.i;    
    if (Object.keys(filterModel).length > 0) {
      Object.keys(filterModel).forEach((columnId) => {
        const filterModels = filterModel[columnId];
        if (Object.keys(filterModels).length > 0) {
          const filterStyle = document.createElement('span');
          filterStyle.classList.add('position-relative');
          filter[index].appendChild(filterStyle);
          this.renderer.addClass(filter[index].children[0], 'z-index-0');
          this.renderer.addClass(
            filter[index].children[0],
            'filter-notification'
          );
        }
      });
    } else {
      this.renderer.removeClass(filter[index].children[0], 'z-index-0');
      this.renderer.removeClass(filter[index].children[0],'filter-notification' );
    }
  }

  datetoConvert(value?: any) {
    const dateString = value;
    const currentYear = new Date().getFullYear();
    return moment(dateString, "MMMM DD").year(currentYear).format("YYYY-MM-DD");
  }

   formatDate(value: any): any {
            return moment(value).format("YYYY-MM-DD  hh:mm A");
          }

}
